import { Flex, Select, useToast } from '@chakra-ui/react'
import axios from 'axios'
import { useEffect, useRef, useState } from 'react'
import Button from '../Button/Button'
import DocPage from '../DocPage/DocPage'
import Rating from '../Rating/Rating'
import { TextBox } from '../TextBox'
import CSS from './styles.module.css'
import { SelectMenu } from '../SelectMenu'
import { CircleFlag } from 'react-circle-flags'
import Cookies from 'js-cookie'
import useCheckLimit from '../../hooks/useCheckLimit'
import G2Promotion from '../../assets/images/promotions/G2PromotionalBanner.svg'
import useKeyGenerate from '../../hooks/useKeyGenerate'
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

const IslandContainer = ({ resultVal, limitSet }) => {
  // ChakraUI Toast
  const toast = useToast()
  const keyword = useKeyGenerate()

  // Refs
  const jTitleBox = useRef(null)
  const jIndustryBox = useRef(null)
  const jQuestionBox = useRef(null)

  // Generated Results logic
  const [result, setResult] = useState(0)
  const limitExceeded = useCheckLimit()

  // Interview Questions
  const [IQdata, setIQdata] = useState([])

  // Form Data & thier handlers
  const [JTitle, setJTitle] = useState()
  const [qType, setqType] = useState('')
  const [sLevel, setsLevel] = useState('')
  let lang = 'Eng (US)'

  const jTitleHandler = (e) => {
    if (jTitleBox.current.value !== '') {
      setJTitle(e.currentTarget.value)
    }
  }

  const qTypeHandler = (e) => {
    setqType(e.currentTarget.value)
  }

  const sLevelHandler = (e) => {
    setsLevel(e.currentTarget.value)
  }

  const langChangeHandler = (e) => {
    if (e !== '') {
      lang = `${e}`
    }
  }

  const increaseLimitCount = () => {
    let count = Cookies.get('genCount')
    if (!count) {
      Cookies.set('genCount', '1', {
        expires: 1,
      })
    } else {
      count = parseInt(count) + 1
      Cookies.set('genCount', count.toString(), {
        expires: 1,
      })
    }
  }

  // API Call
  const fetchResult = async () => {
    if (!limitExceeded) {
      if (JTitle !== '') {
        const jobTitle = `${JTitle}. Generate Interview Questions in ${lang} Language.`
        const experienceLevel = `${sLevel}`
        const questionType = `${qType}`

        setResult(1)

        increaseLimitCount()

        setTimeout(() => {
          setResult(2)
        }, 100)
        const header = {
          Authorization: `Bearer ${keyword}`,
        }
        await axios
          .post(
            API_ENDPOINT,
            {
              jobTitle,
              experienceLevel,
              questionType,
            },
            { headers: header }
          )
          .then((res) => {
            if (res && res.data && res.data.choices) {
              setIQdata(JSON.parse(res.data.choices[0].message.content))
            }

            setTimeout(() => {
              setResult(3)
            }, 100)
          })
          .catch((err) => {
            console.error(err)
            setTimeout(() => {
              setResult(2)
              setTimeout(() => {
                setResult(1)
              }, 100)
              toast({
                title: 'Oops!',
                description: 'Something went wrong. Try again.',
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: 'bottom-left',
              })
            }, 53000)
          })
      } else {
        toast({
          description: 'Please fill out Job Title field. (Required)',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'bottom-left',
        })
      }
    } else {
      limitSet(true)
    }
  }

  useEffect(() => {
    setTimeout(() => {
      jTitleBox.current.focus()
    }, 1500)
  }, [])

  useEffect(() => {
    setJTitle(jTitleBox.current.value)
    setqType(jQuestionBox.current.value)
    setsLevel(jIndustryBox.current.value)
  }, [jTitleBox.current, jQuestionBox.current, jIndustryBox.current])

  useEffect(() => {
    resultVal(result)
  }, [result, resultVal])

  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      width="100%"
      style={{ position: 'relative', padding: '0px 15px' }}
    >
      <div
        className={`${CSS.IslandContainer} ${
          result === 3 ? CSS.IC_expanded : ''
        } ${result === 2 ? CSS.IC_Progress : ''}`}
      >
        <div
          className={`${CSS.InputGrid} ${result === 2 ? CSS.IG_Progress : ''}`}
        >
          <TextBox
            placeholder="Job Title"
            className={CSS.JTInput}
            onChange={jTitleHandler}
            ref={jTitleBox}
            required
            wide
          />
          <Select
            variant="filled"
            placeholder="Seniority Level (Optional)"
            height="50px"
            onChange={sLevelHandler}
            ref={jIndustryBox}
            required
          >
            <option value="Beginner">Junior</option>
            <option value="Intermediate">Mid-level</option>
            <option value="Advanced">Senior</option>
          </Select>

          <Select
            variant="filled"
            placeholder="Question type (Optional)"
            height="50px"
            onChange={qTypeHandler}
            ref={jQuestionBox}
            required
          >
            <option value="">All Question types</option>
            <option value="Technical">Technical</option>
            <option value="Behavioral">Behavioral</option>
            <option value="Competency-based">Competency-based</option>
            <option value="Fact-based">Fact-based</option>
            <option value="Situational">Situational</option>
            <option value="Skill-based">Skill-based</option>
          </Select>

          <SelectMenu
            placeholder="Language"
            outputValue={langChangeHandler}
            defaultValue={lang}
            className={CSS.LangSelect}
            optionalLabel
          >
            <span>
              <CircleFlag countryCode="us" /> Eng (US)
            </span>
            <span>
              <CircleFlag countryCode="uk" /> Eng (UK)
            </span>
            <span>
              <CircleFlag countryCode="es" /> Spanish
            </span>
            <span>
              <CircleFlag countryCode="de" /> German
            </span>
            <span>
              <CircleFlag countryCode="fr" /> French
            </span>
            <span>
              <CircleFlag countryCode="it" /> Italian
            </span>
            <span>
              <CircleFlag countryCode="sa" /> Arabic
            </span>
            <span>
              <CircleFlag countryCode="nl" /> Dutch
            </span>
            <span>
              <CircleFlag countryCode="pt" /> Portugese
            </span>
            <span>
              <CircleFlag countryCode="pl" /> Polish
            </span>
          </SelectMenu>

          <Button
            variant="HeroButton"
            className={CSS.HeroButton}
            leftIcon="bolt"
            onClick={fetchResult}
            disabled={
              result === 3 || result === 1 || result === 0 ? false : true
            }
          >
            {result === 2
              ? 'Generating...'
              : result === 3
              ? 'Regenerate'
              : 'Generate'}
          </Button>
        </div>

        <div
          className={`${CSS.Results} ${
            result === 2 ? CSS.ResultsInprogress : ''
          } ${result === 3 ? CSS.ResultsComplete : ''} ${
            result === 0 ? CSS.ResultsHidden : ''
          }`}
        >
          <div className={CSS.IconIllustration}>
            <div className={CSS.ProcessingIcon}>
              <div className={`${CSS.Sparkles} ${CSS.Sparkle1}`}></div>
              <div className={`${CSS.Sparkles} ${CSS.Sparkle2}`}></div>
              <div className={`${CSS.Sparkles} ${CSS.Sparkle3}`}></div>
            </div>
            <div className={CSS.Steps}>
              <div className={CSS.step}></div>
              <div className={CSS.step}></div>
              <div className={CSS.step}></div>
            </div>
          </div>

          <font>
            Generating your top-class Interview Questions. It may take upto 10
            seconds.
          </font>
        </div>

        {result === 3 && (
          <div className={CSS.PromotionBanner}>
            <a
              href="https://dash.recooty.com/register?referral=ultra&http_referer=https%3A%2F%2Fdash.recooty.com%2F"
              target="_blank"
            >
              <img
                src={G2Promotion}
                alt="Free Job description Generator Banner Ad"
              />
            </a>
          </div>
        )}

        <DocPage isActive={result === 3}>{IQdata}</DocPage>
      </div>
      <div className={CSS.HighlightPoints}>
        <div className={CSS.Point}>
          <span className="material-symbols-outlined">task_alt</span>
          Time Saving
        </div>
        <div className={CSS.Separator}></div>
        <div className={CSS.Point}>
          <span className="material-symbols-outlined">task_alt</span>
          Tailored Questions
        </div>
        <div className={CSS.Separator}></div>
        <div className={CSS.Point}>
          <span className="material-symbols-outlined">task_alt</span>
          Answers Included
        </div>
      </div>
      <Rating
        comment={
          <font>
            Recooty's AI Interview question generator helps us ask the right
            questions to candidates.
            <br /> This tool optimizes our interview process, reduces hiring
            time, and lowers turnover rates. It is so easy for us now to create
            a great Interview questions for any role in seconds.
          </font>
        }
        person="Meghan"
        company="Recruiter"
        className={`${CSS.Rating} ${
          result === 0 ? CSS.RatingInit : CSS.RatingOff
        }`}
      />
    </Flex>
  )
}

export default IslandContainer
